<template>
  <div
    id="tree-menu"
    :style="navStat ? 'width: 220px;background:#312D28;' : 'width:40px;background:#312D28;'"
  >
    <el-menu
      class="el-menu-vertical-demo"
      :collapse="navtest"
      menu-trigger="hover"
      :style="navStat ? 'width: 220px;background:#312D28;' : 'width:40px;background:#312D28;'"
    >
      <el-submenu index="0" :style="navStat ? 'width:220px' : 'width:40px'" class="index-one">
        <template v-slot:title>
          <div :style="!navStat ? 'margin-left:-10px;width:30px;' : ''" class="li-one nav-one">
            <el-input
              suffix-icon="el-icon-search"
              size="mini"
              class="search-menu"
              v-model="navText"
              @change="upNav"
              v-show="navStat"
              placeholder="搜索应用名称"
            ></el-input>
            <i
              :class="navStat ? 'iconfont icon-shousuo sour-90' : 'iconfont icon-shousuo'"
              @click="navStat ? navStat = false : navStat = true"
            ></i>
          </div>
        </template>
      </el-submenu>
      <el-submenu
        v-for="(item, index) in menuData"
        :index="String(index + 1)"
        :key="index"
        v-show="item.stat"
        :style="navStat ? 'width:220px' : 'width:40px'"
      >
        <template v-slot:title>
          <div
            :style="!navStat ? 'margin-left:-10px;' : ''"
            class="li-one"
            @click="openWin(item, index)"
          >
            <i :class="'iconfont ' + item.icon "></i>
            <span class="title ellipsis" v-show="navStat">{{item.title}}</span>
          </div>
        </template>
        <el-menu-item-group :style="'max-height:' + height + 'px;overflow:auto;'">
          <el-menu-item
            :index="(index + 1) + '-' + key"
            v-for="(list, key) in item.value"
            @click="openWinChild(list, index, key)"
            :key="key"
          >{{list.appname}}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
    <div id="addStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'treeMenu',
  props: ['menuData'],
  data () {
    return {
      // active:0,
      // ulShow:0,
      // ulActive:0,
      navtest: true,
      height: 0,
      navStat: true,
      navText: ''
    }
  },
  watch: {
    navText: function () {
      this.upNav()
    },
    navStat: function (val) {
      if (!val) {
        this.navText = ''
        this.upNav()
      }
    }
  },
  methods: {
    upNav () {
      this.$emit('searchMenuData', this.navText)
    },
    openWin (item, key) {
      console.log(item, key)
      if (item.approvalId) {
        this.$emit('childTreeMethods', item);
      } else {
        // TODO
      }
    },
    openWinChild (item) {
      if (item.approvalId) {
        this.$emit('childTreeMethods', item);
      } else {
        // TODO
      }
    },
    addMound () {
      //这块是防止css冲突的东西
    },
  },
  mounted () {
    let H = window.innerHeight ? window.innerHeight : document.body.offsetHeight ? document.body.offsetHeight : document.documentElement.clientHeight
    this.height = H - 24 - 50
    this.addMound()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/*
  #tree-menu .el-submenu {
    width: 220px;
  }
*/
#tree-menu .el-submenu:nth-child(1) .el-submenu__title i {
  color: #d9d9d9;
}
#tree-menu .el-submenu:nth-child(1):hover .el-submenu__title:hover i {
  color: #d9d9d9;
}
#tree-menu .el-submenu:nth-child(1):hover .el-submenu__title:hover {
  background: #201a14 !important;
}
#tree-menu .el-submenu:nth-child(1) {
  background: #201a14 !important;
}
#tree-menu .el-submenu__title:hover .title {
  color: #590000;
}
#tree-menu .el-submenu__title:hover i {
  color: #590000;
}
#tree-menu .el-submenu__title:hover {
  background: #19b359;
}
#tree-menu .index-one .el-submenu__title {
  padding: 0 !important;
}
</style>
<style scoped>
/*
  .el-aside{border-right: 1px solid #ccc;position: relative;background:#2B3947;height: 100%;z-index: 10;}
  .el-aside ul li {margin: 12px 0; cursor: pointer;color: #fff;display: block}
  .el-aside ul li.hideListBtn{text-align: center;padding:4px 0;margin: 0; background: #264B6F;}
  .el-aside ul li.hideListBtn i{font-size: 200%;padding:0 }
  .el-aside ul li i{padding:0}
  .el-aside ul li p{padding:12px 0 12px 14px;text-align: left}
  .el-aside ul li p i{padding:0;}
  .el-aside ul li p img{vertical-align: middle;}
  .el-aside ul li p span{padding-left:12px}
  .el-aside ul li p:hover{background: #2C4257}
  .el-aside ul li ul {background: #25313D;}
  .el-aside ul li.active > p{ background:#4e86ff;color: #fff}
  .ulShow{height: auto;}
  .ulHide{height: 0;overflow: hidden;}
*/
.el-menu-vertical-demo {
  width: 220px;
  height: 100%;
  overflow: auto;
  padding-right: 20px !important;
}
.search-menu {
  width: 150px;
}
.title {
  color: #b6b6b6;
  font-size: 14px;
  visibility: inherit !important;
  width: auto !important;
  height: auto !important;
  padding-left: 7px;
}
.title-block {
  color: #ffffff;
  font-size: 14px;
  display: block;
  border: 1px solid red;
}
.sour-90 {
  display: block;
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  transform: scaleX(-1);
  /*IE*/
  filter: FlipH;
  font-size: 18px !important;
  margin-left: 16px;
  cursor: pointer;
}
.li-one {
  display: flex;
  align-items: center;
}
.nav-one {
  position: fixed;
  z-index: 9;
  background: #201a14;
  width: 200px;
  padding-left: 20px;
}
.index-one {
  background: #201a14;
  width: 220px;
  height: 60px;
}
</style>
